import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as actions from '../store';

class Logout extends React.Component {
    async componentDidMount(){
        await this.props.onLogout();
    }
    render() {
        return (<Redirect to="/login" />);
    }
}

const mapDispatchToProps=dispatch=>({
    onLogout:()=>dispatch(actions.logout())
})

export default connect(null,mapDispatchToProps)(Logout);